import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';

import SideMenuList from './SideMenuList';

import './SideMenu.sass'

const SideMenu = (props) => {
	const { t } = useTranslation('translation', { keyPrefix: 'components.sideMenu' });
	const { sideMenuOpen, user, company, updateSideMenuOpen, isHomePage } = props

	const toggleCollapse = (menuItem) => {

		if ($('.sideMenu').hasClass('menuOpenMobile')) {
			$('.sideMenu').removeClass('menuOpenMobile');
			$("body").removeClass('hasMobileMenu');
		}
	}

	const toggleSidenav = () => {

		localStorage.setItem('openState', JSON.stringify(!sideMenuOpen))
		updateSideMenuOpen(!sideMenuOpen)
	}

	if (!user || !company) {
		return <div>{t('textLoading')}</div>
	}

	return (
		<nav className={`sideMenu ${sideMenuOpen ? '' : 'sideMenuMin'}${isHomePage ? ' home-page' : ''}`} aria-label="primary navigation">
			<div className="header-logo-container">
				<Link to="/" className="header-logo" id="rosco-header-logo" />
			</div>
			<div className="expand-wrapper">
				<svg width="32" height="32" viewBox="0 0 24 24" focusable="false" role="presentation" onClick={toggleSidenav}>
					<path d="M10.294 9.698a.988.988 0 0 1 0-1.407 1.01 1.01 0 0 1 1.419 0l2.965 2.94a1.09 1.09 0 0 1 0 1.548l-2.955 2.93a1.01 1.01 0 0 1-1.42 0 .988.988 0 0 1 0-1.407l2.318-2.297-2.327-2.307z" fill="currentColor" fillRule="evenodd" />
				</svg>
			</div>

			<SideMenuList open={sideMenuOpen} onItemClick={toggleCollapse} />

			{isHomePage &&
				<div className="sideMenu-company">
					<div className="sideMenu-company-name">{company.name}</div>
					<div className="sideMenu-company-caption">{t('textCompanyCaption')}</div>
				</div>
			}
		</nav>
	)
}

const mapStateToProps = ({ user, company, dashboardData }) => ({
	user: user.user,
	company: company.company,
	sideMenuOpen: dashboardData.sideMenuOpen,
})

const mapDispatchToProps = dispatch => ({
	updateSideMenuOpen: (user) => {
		dispatch({ type: 'SET_SIDE_MENU_OPEN', payload: user });
	},
})

export default connect(mapStateToProps, mapDispatchToProps)(SideMenu);
